import copy from './apiTestingCopy';
import forms from './apiTestingFormsCopy';

const es = { ...copy, ...forms };

export const apiTestingTranslator = (language) => (text, values = {}) => {
  if (typeof text !== 'string') return text;
  const translated = language === 'es' ? (es[text] ?? text) : text;
  // Replace placeholders in template copy only, never inside supplied user values.
  return translated.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
};
